export default [
    {
        key: "Alfa numérico",
        value: false
    },
    {
        key: "Nome do produto",
        value: false
    },
    {
        key: "ID do Produto",
        value: false
    },
    {
        key: "Linha",
        value: false
    },
];